import { useV2ListRateTablesForAccountQuery } from "@generated";

export interface RateTableOption {
  label: string;
  value: string;
}

const useListRateTables = () => {
  let customError: string | null = null;

  const { data, error, isLoading } = useV2ListRateTablesForAccountQuery({});

  let rateTables: RateTableOption[] = [];

  if (data?.data) {
    try {
      const mapped = data.data
        .filter((rt) => rt.id && rt.attributes?.name)
        .map((rt) => ({
          value: String(rt.id),
          label: rt.attributes.name,
          isDefault: !!(rt.attributes as any)?.default,
        }));
      mapped.sort((a, b) => Number(b.isDefault) - Number(a.isDefault));
      rateTables = mapped.map(({ value, label }) => ({ value, label }));
    } catch (err) {
      customError =
        err instanceof Error ? err.message : "An unknown error occurred";
    }
  }

  return {
    rateTables,
    rateTablesLoading: isLoading,
    error: error ?? customError,
  };
};

export default useListRateTables;
